import { SbMarqueeBetbuilderComponent } from "./sb-marquee-betbuilder/sb-marquee-betbuilder";
export { SbMarqueeBetbuilderComponent } from "./sb-marquee-betbuilder/sb-marquee-betbuilder";

import { SbMarqueeComponent } from "./sb-marquee/sb-marquee";
export { SbMarqueeComponent } from "./sb-marquee/sb-marquee";

export const Components: any[] = [SbMarqueeBetbuilderComponent, SbMarqueeComponent];
